// extracted by mini-css-extract-plugin
module.exports = {"container":"open-account-offer-main_container__mMcGd","btn":"open-account-offer-main_btn__PmHhN"};